/* eslint-disable react/no-danger */
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';

import './Modal.css';

import { useState, useContext } from 'react';
import FocusLock from 'react-focus-lock';
import { useTranslation } from 'react-i18next';

import { Button } from '../components/button/Button';
import { AuthContext } from '../context/auth-context';
import useKeyboardAction from '../hooks/useKeyboardAction';

type WelcomeAfterAssessmentModalProps = {
  onModalClose: () => void;
};

export function WelcomeAfterAssessmentModal({ onModalClose }: WelcomeAfterAssessmentModalProps) {
  const [stage, setStage] = useState(1);
  const auth = useContext(AuthContext);
  const { t } = useTranslation();

  useKeyboardAction(() => {
    onModalClose();
  }, 'Escape');

  const getPageOptions = () => {
    switch (stage) {
      case 1:
        return {
          title: `${t('O019')} ${auth.fname}!`,
          text: `<p>${t('O018')}</p>`,
          buttonText: t('O003'),
        };
      case 2:
        return {
          title: t('O011'),
          text: `<p>${t('O012')}</p>`,
          buttonText: t('O003'),
        };
      case 3:
        return {
          title: t('O013'),
          text: `<p>${t('O014')}</p>`,
          buttonText: t('O003'),
        };
      case 4:
        return {
          title: t('O015'),
          text: `<p>${t('O016')}</p>`,
          buttonText: t('O017'),
        };
      default:
        return {
          title: '',
          text: '',
          buttonText: '',
        };
    }
  };

  const onButtonClick = () => {
    const newStage = stage + 1;
    if (newStage <= 4) {
      setStage(newStage);
    } else {
      onModalClose();
    }
  };

  const { title, text, buttonText } = getPageOptions();

  return (
    <FocusLock returnFocus>
      <>
        <div className="backdropOffboarding" />
        <div
          role="dialog"
          id="modal-container-onboarding"
          className="open"
          aria-modal="true"
          tabIndex={-1}
          aria-labelledby="onboardingModalTitle"
        >
          <span className="sr-only">{t('modal.onboarding.welcome')}</span>
          <div key={stage} className="onboarding-stage-content">
            <div
              id={`offboarding_image_${stage}`}
              className="left_side_onboarding"
              aria-hidden="true"
            />

            <div className="right_side_onboarding">
              <p id="onboardingModalDesc" className="onboarding_modal_text" aria-hidden="true">
                {t('O019')}
              </p>
              <h2 aria-live="polite" id="onboardingModalTitle">
                {title}
              </h2>
              <div id="onboardingModalText" dangerouslySetInnerHTML={{ __html: text }} />
              <div aria-hidden="true" id="section_progress" className="foryou">
                {[1, 2, 3, 4].map((s) => (
                  <div key={s} className={stage === s ? 'section_bar active' : 'section_bar'} />
                ))}
              </div>

              <Button
                type="button"
                onClick={onButtonClick}
                icon={{ faIconDefinition: faArrowRight }}
                iconPosition="right"
              >
                {buttonText}
              </Button>
            </div>
          </div>
        </div>
      </>
    </FocusLock>
  );
}
